import { render, staticRenderFns } from "./lkuFassetLazzy.vue?vue&type=template&id=244f9dba"
import script from "./lkuFassetLazzy.vue?vue&type=script&lang=js"
export * from "./lkuFassetLazzy.vue?vue&type=script&lang=js"
import style0 from "./lkuFassetLazzy.vue?vue&type=style&index=0&id=244f9dba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports